import { render } from "./Categories-tab-page.vue?vue&type=template&id=28986a66&scoped=true"
import script from "./Categories-tab-page.vue?vue&type=script&lang=js"
export * from "./Categories-tab-page.vue?vue&type=script&lang=js"

import "./Categories-tab-page.vue?vue&type=style&index=0&id=28986a66&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28986a66"]])

export default __exports__